import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
const OFFER_URL = 'https://www.apwkk8trk.com/94J6RZ/293Z4R/';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="md:hidden fixed bottom-0 left-0 right-0 p-3 bg-white/95 backdrop-blur-sm border-t border-gray-200 shadow-[0_-4px_10px_rgba(0,0,0,0.05)] z-50" data-id="element-65">
      <a href={OFFER_URL} className="flex items-center justify-center gap-2 w-full font-bold text-white bg-[#F5A623] hover:bg-[#D4891A] text-base py-3.5 rounded-xl shadow-lg no-underline transition-colors" data-id="element-66">
        Check Prices in My Area
        <ArrowRightIcon className="w-5 h-5" data-id="element-67" />
      </a>
    </div>;
}